import { skus, OfferingAllowances, Sku } from "../model/data";

const allSkus = Object.values(skus) as Sku[];

export function validate(data: unknown): asserts data is OfferingAllowances {
    if (typeof data !== "object" || data === null || Array.isArray(data)) {
        throw new Error(
            `Invalid product catalog data: expected a non-null object, got ${
                data === null
                    ? "null"
                    : Array.isArray(data)
                    ? "array"
                    : typeof data
            }`
        );
    }

    const record = data as Record<string, unknown>;

    const missingSku = allSkus.find((sku) => !(sku in record));
    if (missingSku !== undefined) {
        throw new Error(
            `Invalid product catalog data: missing entry for SKU "${missingSku}"`
        );
    }

    for (const sku of allSkus) {
        if (!isOfferingAllowance(record[sku])) {
            throw new Error(
                `Invalid product catalog data: entry for SKU "${sku}" does not match OfferingAllowance shape`
            );
        }
    }
}

function isOfferingAllowance(value: unknown): boolean {
    if (typeof value !== "object" || value === null) {
        return false;
    }
    const v = value as Record<string, unknown>;

    for (const field of ["aiCredit", "indexedDocument"] as const) {
        const entry = v[field];
        if (typeof entry !== "object" || entry === null) {
            return false;
        }
        const e = entry as Record<string, unknown>;
        if (
            typeof e["monthly"] !== "number" ||
            typeof e["annual"] !== "number"
        ) {
            return false;
        }
    }

    return true;
}
